import { NavLink } from 'react-router-dom'
import {
  media as SubMenuMedia,
  service as SubMenuService,
  knowledge as SubMenuKnowledge,
} from './SubMenu/MediaSubMenuItems'
const NavigatorMenuItems = ({ mobile = false }: { mobile?: boolean }) => {
  return (
    <ul className="navigation clearfix">
      {/* Active class = current */}
      <li>
        <NavLink to="/">
          หน้าหลัก
        </NavLink>
      </li>
      <li className="dropdown">
        <a
          href="#"
          // className={pathname.match(/media/g)?'current':''}
        >
          อย. บริการประชาชน
        </a>
        <SubMenuService />
        {mobile && (
          <div className="dropdown-btn">
            <span className="fa fa-angle-down"></span>
          </div>
        )}
      </li>
      <li className="dropdown">
        <a href="#">ประเภทสื่อ</a>
        <SubMenuMedia />
        {mobile && (
          <div className="dropdown-btn">
            <span className="fa fa-angle-down"></span>
          </div>
        )}
      </li>
      <li className="dropdown">
        <a href="#">เรื่องน่ารู้</a>
        <SubMenuKnowledge />
        {mobile && (
          <div className="dropdown-btn">
            <span className="fa fa-angle-down"></span>
          </div>
        )}
      </li>

      <li className="">
        <NavLink to="contact">ติดต่อ อย.</NavLink>
      </li>
    </ul>
  )
}
export default NavigatorMenuItems
